import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bir-select-item',
  templateUrl: './bir-item.component.html',
  styles: [],
  standalone: false
})
export class BirItemSelectItemComponent {
  @Input() bir: any = {};

  get name() {
    if (this.bir) {
      if (this.bir.classification === 2) {
        return [this.bir.lastName, this.bir.firstName, this.bir.middleName]
          .filter(x => x)
          .join(', ');
      }
      return this.bir?.companyName;
    }
    return '';
  }
  get tin() {
    return `${this.bir.tinNumber} - (${this.bir.tinBranchCode})`;
  }
  constructor() {}
}
